import { render, staticRenderFns } from "./tax-adjust.vue?vue&type=template&id=2f4dc4ac"
import script from "./tax-adjust.vue?vue&type=script&lang=js"
export * from "./tax-adjust.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports